import { RootState } from '../reducers';

export namespace PermissionSelectors {
	export const getPermissions = (state: RootState) => state.permissions;
}
